import { X } from 'lucide-react';
import { sanitizeInlineHtml } from '../utils/sanitizeHtml';

interface AnnouncementBarSettings {
  id: string;
  is_enabled: boolean;
  message: string;
  background_color: string;
  text_color: string;
  font_family: string;
}

interface AnnouncementBarProps {
  settings: AnnouncementBarSettings;
  onClose: () => void;
}

export function AnnouncementBar({ settings, onClose }: AnnouncementBarProps) {
  return (
    <div
      className="fixed top-20 left-0 right-0 z-40 border-b"
      style={{
        backgroundColor: settings.background_color,
        color: settings.text_color,
        fontFamily: settings.font_family,
      }}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between min-h-[60px] py-3">
          <div
            className="flex-1 text-center px-4"
            dangerouslySetInnerHTML={{ __html: sanitizeInlineHtml(settings.message) }}
            style={{
              color: settings.text_color,
            }}
          />

          <button
            onClick={onClose}
            className="ml-4 transition-colors flex-shrink-0 opacity-70 hover:opacity-100"
            aria-label="Close announcement"
            style={{ color: settings.text_color }}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
